module.exports = __webpack_public_path__ + "static/media/40.6b8fa434.JPG";